import React, { useState } from 'react';
import './App.css'; // Custom CSS for styling the image gallery

const Gallery1 = () => {
    // Manually defined images instead of fetching from a database
    const images = [
      { imageData: "/images/shoot15.webp" },
             { imageData: "/images/coco2.webp" },
             { imageData: "/images/bride.webp" },
             { imageData: "/images/celebration.webp" },// Replace with the actual path or URL
             { imageData: "/images/shoot12.webp" },
             { imageData: "/images/shoot10.webp" },
             { imageData: "/images/pacl6.webp" }, // Replace with the actual path or URL
                     { imageData: "/images/shoot9.webp" },
                     { imageData: "/images/shoot2.webp" },
                      { imageData: "/images/coco4.webp" },
                      { imageData: "/images/g3.webp" },
                      { imageData: "/images/g7.webp" },
                      { imageData: "/images/image12.webp" },
                      { imageData: "/images/image13.webp" },
                                     { imageData: "/images/shoot8.webp" },
        // Add more images as needed
    ];

    const navigateMoreGallery = () => {
        // Replace with the actual navigation logic, e.g., using react-router-dom
        window.location.href = '/galleries';
    };

    return (
        <div className="gallery-page">
            <header className="gallery-header">
                <h1>Creating memories as fresh as morning dew</h1>
                <p>
                    Memories are like windows to the past, capturing moments of joy, love, and growth that shape who we are.
                    They hold the essence of our experiences, both big and small, preserving the laughter, lessons, and even the bittersweet times.
                    Whether vivid or faint, each memory tells a story, reminding us of the people we've met, the places we've been,
                    and the journey we've traveled. In memories, we find comfort, reflection, and sometimes the spark of inspiration for what comes next.
                </p>
                <button className="gallery-button" onClick={navigateMoreGallery}>
                    Explore More Gallery
                </button>
            </header>

            <div className="gallery-container">
                {images.length > 0 ? (
                    images.map((image, index) => (
                        <div key={index} className="image-wrapperr">
                            <img
                                src={image.imageData} // Directly using the image path
                                
                                className="gallery-image" // Apply styling from CSS
                            />
                        </div>
                    ))
                ) : (
                    <p>No images available in the gallery.</p>
                )}
            </div>
        </div>
    );
};

export default Gallery1;
